import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import { toIDR } from '../../../../../_utils/tocurrency';
import { 
   Menu, Icon, Label, Form, Select, Button, Loader, Message, Pagination
} from 'semantic-ui-react';
import _ from 'lodash';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import swal from 'sweetalert'
import printJS from 'print-js';
import moment from 'moment'
import { fetchOPD } from '../../../../../_utils/localstorage';

export default class BPLaporan2 extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [],
            requests:false,
            
            startDate: null,
            endDate: null,
            status_val: null,

            total:[],
            status:[],
            jumlah:0,
            semua:true,
            semua_data:[],
            
            opds: [],
            opd_kode: null,
            opd_name: null,
            
            rekenings: [],
            kode_rekening: null,
            nama_rekening: null,

            activePage: 1,
            totalPages: 0,
            pageActive: 1,
        }
        this.onFilter = this.onFilter.bind(this);    
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onChangeOPD = this.onChangeOPD.bind(this);  
    }

    handlePaginationChange = (e, { activePage }) => {
        if (this.state.pageActive === activePage){
            return false;
        }

        this.setState({ activePage, pageActive: activePage, requests: true })
        fetch(`${BaseURLDev}/bp?report=true&page=${activePage}&status=1`,{headers})
        .then(response => {
            if (!response.ok) { 
                  return Promise.reject(response.statusText);
              }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                semua_data:semua_data,
                requests:false,
                totalPages:4,
            })
        });
    }

    opdSelect(){
        if(fetchOPD().length!==0){
           const opds = []
        //    opds.push({'value':0,'text':"Semua Data",'key':10000})         
           for(let i=0; i<fetchOPD().length; i++) {
              opds.push({
                 'value': i,
                 'text': `[${fetchOPD()[i].kode_opd}] ${fetchOPD()[i].opd}`,
                 'key': fetchOPD()[i].kode_opd,     
              })
           }
           this.setState({opds:opds})
        }
    }


    onChangeOPD(e, el){

    }

    getDataRekening(){
        fetch(`${BaseURLDev}/simantra/ref/allrek6`,{ headers })
        .then(response => {
           if(!response.ok){
              return Promise.reject(response.statusText);
           }
           return response.json()
        })
        .then(resJSON => {
        //    var {skpd,user} = JSON.parse(sessionStorage.data);
        //    sessionStorage.setItem('data',JSON.stringify({
        //       user:user,
        //       opd:resJSON.data,
        //       skpd:skpd
        //    }))
           
            const rekenings = []
            for(let i=0; i<resJSON.data.length; i++) {
                rekenings.push({
                    'value': i,
                    'text': `[${resJSON.data[i].kd_rek}] ${resJSON.data[i].nm_rek}`,
                    'key': resJSON.data[i].kd_rek    
                })
            }
            this.setState({ rekenings: rekenings })
        })
    }

    onRefresh(){
        this.setState({
            startDate:null,
            endDate:null,
            requests:true
        })

        fetch(`${BaseURLDev}/bp?report=true`,{headers})
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
        });
    }

    onFilter(){
        const { startDate, endDate, status_val, opd_kode, kode_rekening } = this.state;
        const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
        const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
        if(startDate===null || endDate===null){
            swal('Pilih range tanggal dulu!',  { icon:'error' });
            this.setState({data: []});
            return false;
        }


        this.setState({requests:true});
        fetch(`${BaseURLDev}/bp?laporan=true&status_val=${status_val}&start=${start_date}&end=${end_date}&opd=${opd_kode.key}&rekening=null`,{headers})
        .then(response => {
            if (!response.ok) {
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            this.setState({
                data: resJSON.data,
                requests: false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            });
        });
    }

    onLoadBP(){
        fetch(`${BaseURLDev}/bp?report=true`,{headers})
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
        });
    }
    componentWillMount(){
        this.opdSelect();
        this.getDataRekening();
    }

    onChangeStatus(e,el){
        this.setState({data: []})
        if(el.value==="10000"){
            this.setState({semua:true})
        } else { 
            this.setState({semua:false})
        }
        this.setState({
            status_val:el.value
        })
    }

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:'Rincian BP',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
     }
    
    add_nilai(nameKey, nilai, myArray){
        for (let i=0; i < myArray.length; i++) {
            if (myArray[i].no_rek === nameKey) {
                let nilai_new = myArray[i].nilai + nilai;
                myArray[i].nilai = nilai_new;
                return myArray[i]
            }
        }
    }

    search(nameKey, myArray){
        for (let i=0; i < myArray.length; i++) {
            if (myArray[i].no_rek === nameKey) {
                return myArray[i]
            }
        }
    }

    render() {
        var data_rekening = []
        var self = this;
        _.map(this.state.data, (item,i) => {
            if(item !== null){
                if(self.search(item.str_kd_rek, data_rekening)){
                    self.add_nilai(item.str_kd_rek, item.nilai, data_rekening)
                }
                else{
                    let data_rek = {
                        no_rek: item.str_kd_rek,
                        nama_rek: item.uraian_rinc,
                        nilai: item.nilai,
                    }
                    data_rekening.push(data_rek)
                }
            }
        })
        const styletb = {
            borderCollapse:'collapse',
            borderSpacing:0,
            borderStyle:'solid',
            width:'100%',
            fontSize:'12px',
            padding:'40px'
        }
        var total_nilai = 0;
        const { data, activePage, startDate, endDate, Date} = this.state;
        const status_bp = [
            {'key':1,'text':'BP (Non STS)','value':"1"},
            {'key':2,'text':'BP (STS)','value':"2"},
            {'key':3,'text':'BP (Terealisasi)','value':"3"},
        ]
        const status_bp_str = [
            {'text':''},
            {'text':'BP (Non STS)'},
            {'text':'BP (STS)'},
            {'text':'BP (Terealisasi)'},
        ]
        if(data.length){
            _.map(data, (item,i) => {
                if(item !== null){
                    total_nilai = total_nilai + item.nilai
                }
            })
        }
        return (
            <div>
                <div>   
                <Message
                    error
                    header='** Penting!'
                    content='Silahkan memilih OPD, Status, serta Rentang Tanggal terlebih dahulu sebelum menekan tombol Filter'
                />                  
                <Menu>
                    <Menu.Item>
                        <Form.Field 
                            control={Select} 
                            search 
                            onChange={(e,el) => this.setState({
                                opd_kode: el.options[el.value],
                                opd_name: el.options[el.value].text,
                            })} 
                            options={this.state.opds} 
                            name="pilihopd" 
                            placeholder='--Pilih OPD--'
                            title='Pilih OPD'
                            style={{width:'250px'}}
                        />
                    </Menu.Item>
                    {/* <Menu.Item>
                        <Form>
                            <Form.Field
                                style={{marginBottom:'6px', width:'250px'}}
                                control={Select} 
                                search          
                                options={this.state.rekenings}
                                onChange={(e,el)=>this.setState({
                                    kode_rekening: el.options[el.value],
                                    nama_rekening: el.options[el.value].text,
                                })}
                                placeholder='--Pilih Rekening--'
                                title='Pilih Rekening'
                            />
                        </Form>
                    </Menu.Item>  */}
                    <Menu.Item>
                        <Form>
                            <Form.Field
                                style={{marginBottom:'6px', width:'250px'}}
                                control={Select} 
                                search          
                                options={status_bp}
                                onChange={this.onChangeStatus} 
                                placeholder='Pilih Status'
                                ttile='Pilih Status'
                            />
                        </Form>
                    </Menu.Item> 
                    <Menu.Item>
                        <DateRangePicker
                            hideKeyboardShortcutsPanel
                            reopenPickerOnClearDates
                            showClearDates
                            minimumNights={0}
                            withPortal
                            showDefaultInputIcon
                            displayFormat="DD/MM/YYYY"
                            small={true}                              
                            numberOfMonths={2}
                            startDatePlaceholderText="Awal"
                            endDatePlaceholderText="Akhir"
                            startDateId="startDateId"
                            endDateId="endDateId"
                            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        />
                    </Menu.Item>
                </Menu>
                <Menu>
                    <Menu.Item>                     
                        <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                            <p><Icon name='print' className='left floated' />Preview</p>
                        </Button>
                    </Menu.Item>
                    <Menu.Item position="right">
                        <Button color='green' size="small" onClick={this.onFilter}
                            disabled={this.state.startDate===null && this.state.endDate===null}> 
                            <p><Icon name='filter' className='left floated' />Filter</p>
                        </Button>
                    </Menu.Item>
                </Menu>
                <div ref={el => (this.componentRef = el)} id="print_data">
                <style type="text/css">
                    {"@media print{@page {size: landscape}}"}
                </style>
                <br/>
                  <div>
                  <br/>
                  {/* <Segment> */}
                  {(this.state.requests || this.state.loading_edit || this.state.loading_detail) ?
                      <Loader active inline='centered' size='medium'>Loading...</Loader>
                  : <div>
                      <table border="1" style={styletb} width="100%">
                        <tr style={{background:'#e5e5e5'}}>
                            <td style={{padding:'4px', width:'10%'}} align="left">OPD</td>
                            <td style={{padding:'4px'}} align="left">
                                :&nbsp;&nbsp;{this.state.opd_name}
                            </td>
                        </tr>
                        {/* <tr style={{background:'#e5e5e5'}}>
                            <td style={{padding:'4px', width:'10%'}} align="left">Rekening</td>
                            <td style={{padding:'4px'}} align="left">
                                :&nbsp;&nbsp;{this.state.nama_rekening}
                            </td>
                        </tr> */}
                        <tr style={{background:'#e5e5e5'}}>
                            <td style={{padding:'4px', width:'10%'}} align="left">Tanggal</td>
                            <td style={{padding:'4px'}} align="left">
                                :&nbsp;&nbsp;{startDate===null ? null : startDate.format('DD-MM-YYYY')} s/d {endDate===null ? null : endDate.format('DD-MM-YYYY')}
                            </td>
                        </tr>
                        <tr style={{background:'#e5e5e5'}}>
                            <td style={{padding:'4px', width:'10%'}} align="left">Status</td>
                            <td style={{padding:'4px'}} align="left">
                            :&nbsp;&nbsp;{this.state.status_val !== null ? status_bp_str[this.state.status_val].text : ''}
                            </td>
                        </tr>
                    </table><br />
                    <table border="1" align="center" style={styletb} width="100%">
                        <tbody>            
                            <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                <th width="3%" style={{padding:'4px',textAlign:"center"}}>No.</th>
                                <th width="10%"style={{padding:'4px',textAlign:"left"}}>Nomor Rekening</th>
                                <th width="40%" style={{padding:'4px',textAlign:"left"}}>Nama Rekening</th>
                                <th width="20%" style={{padding:'4px',textAlign:"right"}}>Total</th>
                            </tr>
                            {data.length === 0 && 
                                <tr>
                                    <th colSpan="9">Data tidak ditemukan</th>                           
                                </tr>
                            }
                            {_.map(data_rekening, (item,i) => {
                                // if(item !== null){
                                    return <tr key={i}> 
                                        <td style={{padding:'4px',textAlign:"center"}}>{i+1}.</td>   
                                        <td style={{padding:'4px',textAlign:"left"}}>{item.no_rek}</td>
                                        <td style={{padding:'4px',textAlign:"left"}}>{item.nama_rek}</td>
                                        <td style={{padding:'4px'}} align="right">{toIDR(item.nilai)}</td>
                                    </tr>
                                // }
                            })}
                        </tbody>   
                    </table><br />
                    <table border="1" align="center" style={styletb} width="100%">
                        <tr style={{background:'#e5e5e5'}}>
                            <th style={{padding:'4px', width:'80%'}} align="right">Total</th>
                            <th style={{padding:'4px'}} align="right">
                                {toIDR(total_nilai)}
                            </th>
                        </tr>
                    </table>
                    </div>
                    }
                  </div>
                  </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report_admin/BPLaporan2.js